import React, { useState } from "react";
import { FiEdit, FiSearch, FiTrash } from "react-icons/fi";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Loader from "../../commonComponent/Loader";
import { isPast, parseISO } from "date-fns";
import { AiFillEye, AiOutlinePlus } from "react-icons/ai";
import {
  formatNewDateString,
  showToastError,
  showToastSuccess,
  sortArrLatest,
} from "../../Utils/Helper";
import {
  activateProgram,
  deleteProgram,
  getActiveProgram,
  getAssignedProgram,
  getDefaultProgram,
  getGroupListForProgram,
  getProgramShareLink,
  removeAssignedProgramFromProvider,
  setDefaultProgram,
  updateActiveProgramById,
  updateCareTeamActiveProgramById,
} from "../../services/ActivePrograms";
import {
  addArchiveCareplan,
  assignGroupToCarePlanService,
} from "../../services/CreateCarePlanService";
import { useEffect } from "react";
import DeleteModal from "../../commonComponent/DeleteModal";
import ApiConfig from "../../config/ApiConfig";
import { BsThreeDots } from "react-icons/bs";
import { Dropdown } from "react-bootstrap";
import { useAuth } from "../../Context/AuthContext";
import ShareLinkModal from "../carePlan_/ShareLinkModal";
import Sidebar from "../sidebar/Sidebar";
import Navbar from "../header/Navbar";
import AssignMemberModal from "./AssignToMembers";
import AssignGroupModal from "./AssignToGroupsModal";
import AssignProvidersModal from "./AssignToProvidersModal";
import { toast } from "react-toastify";
import { useTabList } from "../../Context/TabListContext";

const defaultTabs = {
  active: false,
  assigned: false,
  archived: false,
  default: false,
};

const ActiveProgramList = () => {
  const navigate = useNavigate();
  const { programTabList, setProgramTabList } = useTabList()
  const { isAdmin } = useAuth();
  const [isLoading, setLoader] = useState(true);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const state = location.state;
  // const {tab} = location.state;
  const [assignedData, setAssignedData] = useState();
  const { userId } = useParams();
  const [listTabs, setListTabs] = useState({
    active: true,
    assigned: false,
    archived: false,
    default: false,
  });
  const [linkInput, setLinkInput] = useState("");
  // const newCreatedProgramId = state?.newCreatedProgramId; // To Check whether new program is created or not if yes then directly navigate to Active program tab screen module
  const [filterdata, setFilterData] = useState([]);
  const [programList, setProgramList] = useState([]);
  const [programGroups, setProgramGroups] = useState([]);
  const [programsGroups, setProgramsGroups] = useState([]);
  const [programMembers, setProgramMembers] = useState([]);
  const [programProviders, setProgramProviders] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState("");
  const [assignedModal, setAssignedModal] = useState(false);
  const [dropDownList, setDropDownList] = useState(false);

  useEffect(() => {
    if (programTabList === 'default') {
      setListTabs({ ...defaultTabs, default: true });
      getDefaultProgramList();
    } else if (programTabList === 'assigned') {
      setListTabs({ ...defaultTabs, assigned: true });
      getAssignedText();
    } else {
      setListTabs({ ...defaultTabs, active: true });
      getAssignedText();
      getProgramList();
    }
    setProgramTabList('')
  }, []);

  useEffect(() => {
    getAssignedText();
  }, [listTabs.assigned]);

  useEffect(() => {
    if (userId && programList.length) {
      const result = programList.filter((value) => value._id === userId);
      if (result.length) {
        setSelectedProgram(result[0]);
        navigate(`/activeprogramlist/${result[0]._id}`, { replace: true });
      } else {
        if (programList?.length) {
          setSelectedProgram(programList[0]);
        }
        // showToastError(toastMsg.programNotAvailable)
      }
    }
  }, [userId, programList]);

  // To get All active program list
  const getProgramList = async () => {
    setLoader(true);
    setFilterData([]);
    try {
      const response = await getActiveProgram();
      // console.log(response, new Date(), "program response")
      console.log(response, "response")

      if (response.status === 200) {
        const result = response.data.data.filter((value) => {
          return !isPast(parseISO(value.endDate));
        });
        setProgramList(result);
        const filteredResult = result.filter((item) => !item.isArchive);
        setFilterData(sortArrLatest(filteredResult));
        setLoader(false);

        if (userId) {
          const firstActiveProgram = filteredResult[0];
          if (firstActiveProgram) {
            navigate(`/activeprogramlist/${firstActiveProgram._id}`, {
              replace: true,
            });
          }
        }
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const renderModal = (item, T, F) => {
    return !isAdmin && assignedData?.length > 0 && item?.careTeam?.length > 0
      ? T
      : F;
  };

  const onChangeSearchText = async (e) => {
    let searchWord = e.target.value;
    const result = programList?.filter((value) => {
      if (value) {
        return value?.programName
          ?.toLowerCase()
          ?.includes(searchWord?.toLowerCase());
      }
    });

    if (searchWord === "") {
      setFilterData(programList);
      // getForumsById(searchWord);
    } else {
      setFilterData(result);
    }
  };

  const getArchivedText = async () => {
    // setLoader(true);
    setLoader(true);
    setFilterData([]);
    try {
      // const response = await getActiveProgram();
      const [activeList, assignedList] = await Promise.all([
        getActiveProgram(),
        getAssignedProgram(),
      ]);
      const response = [...activeList.data.data, ...assignedList.data.data];
      console.log(response, new Date(), "program response");

      if (activeList.status === 200 && assignedList.status === 200) {
        // setProgramList(response?.data?.data);
        // setFilterData(response?.data?.data);
        const result = response?.filter((value) => {
          console.log(value, "result");
          if (value.isArchive) {
            return value;
          }
        });
        setProgramList(result);
        setFilterData(sortArrLatest(result));
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const addArchive = async (programId) => {
    let parms = {
      Id: programId,
      Type: "program",
    };
    try {
      if (parms) {
        // console.log("careplanId", programId);
        const response = await addArchiveCareplan(parms);
        if (!response?.data?.status === 200) {
          toast.error(`status:${response?.data?.status}`);
        }
        // setProgramList(response?.data?.data);
        // setFilterData(response?.data?.data);
        if (response?.data?.data.isArchive === false) {
          showToastSuccess(`Program Unarchived`);
        } else {
          showToastSuccess(`Program Archived`);
        }
        listTabs.active && getProgramList();
        listTabs.default && getDefaultProgramList();
        listTabs.assigned && getAssignedText();
        listTabs.archived && getArchivedText();
      } else {
        toast.error("Group Id is not available");
      }
    } catch (response) {
      toast.error(response?.data?.data);
    }
  };
  const getAssignedText = async () => {
    // setLoader(true);
    setLoader(true);
    setFilterData([]);

    try {
      const response = await getAssignedProgram();

      if (response.status === 200) {
        const result = response?.data?.data?.filter((value) => {
          if (!value.isArchive) {
            return value;
          }
        });
        if (listTabs.assigned) {
          setProgramList(result);
          setFilterData(sortArrLatest(result));
          setLoader(false);
        }
        setAssignedData(result);
        // setProgramList(result);
        // setFilterData(result);
      }
    } catch (error) {
      setLoader(false);
    }
  };
  const updateProgram = async () => {
    setLoader(true);
    // console.log(programMembers, "clients", selectedProgram)
    try {
      const fileName = selectedProgram.programImage.split("/");
      const imageName = fileName[fileName.length - 1];
      const response = assignedModal
        ? await updateCareTeamActiveProgramById(selectedProgram._id, {
          ...selectedProgram,
          programImage: imageName,
          programMembers: programMembers,
        })
        : await updateActiveProgramById(selectedProgram._id, {
          ...selectedProgram,
          programImage: imageName,
          programMembers: programMembers,
        });
      if (response) {
        showToastSuccess("Members Assigned Successfully");
        getAssignedText();
        listTabs.active && getProgramList();
        listTabs.default && getDefaultProgramList();
        listTabs.assigned && getAssignedText();
        listTabs.archived && getArchivedText();
        // props.onRefresh()
        setProgramMembers([]);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  let dateSort = (filterdata1) => {
    setDropDownList(false);
    const result = filterdata1.sort(function (a, b) {
      a = new Date(a.createdAt);
      b = new Date(b.createdAt);
      return a > b ? -1 : a < b ? 1 : 0;
    });
    return result;
  };
  let nameSort = (filterdata1) => {
    setDropDownList(false);
    const result = filterdata1.sort(function compare(a, b) {
      if (a.programName.toLowerCase() < b.programName.toLowerCase()) {
        return -1;
      }
      if (a.programName.toLowerCase() > b.programName.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    return result;
  };
  let membershipCountSort = (filterdata1) => {
    setDropDownList(false);
    const result = filterdata1.sort(function compare(a, b) {
      const aCareTeamMembers = a.careTeamMembers?.length + a.programMembers?.length
      const bCareTeamMembers = b.careTeamMembers?.length + b.programMembers?.length
      if (aCareTeamMembers > bCareTeamMembers) {
        return -1;
      }
      if (aCareTeamMembers < bCareTeamMembers) {
        return 1;
      }
      return 0;
    });
    return result;
  };
  

  const updateProviders = async (list) => {
    setLoader(true);
    try {
      const fileName = selectedProgram.programImage.split("/");
      const imageName = fileName[fileName.length - 1];
      const response = await updateActiveProgramById(selectedProgram._id, {
        ...selectedProgram,
        programImage: imageName,
        careTeam: list,
      });
      if (response) {
        showToastSuccess("Providers Assigned Successfully");
        listTabs.active && getProgramList();
        listTabs.default && getDefaultProgramList();
        listTabs.assigned && getAssignedText();
        listTabs.archived && getArchivedText();
        // props.onRefresh()
        setProgramProviders([]);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  const updateGroups = async () => {
    setLoader(true);
    try {
      const response = await assignGroupToCarePlanService({
        programId: [selectedProgram._id],
        groupId: programsGroups,
      });
      if (response) {
        showToastSuccess("Groups Assigned Successfully");
        // getCarePlanList();
        // props.onRefresh()
        setProgramGroups([]);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  const getShareLink = async (programId) => {
    try {
      const response = await getProgramShareLink(programId);
      setLoader(false);

      if (response.status === 200) {
        setLinkInput(response?.data);
      } else {
        alert(response?.data || response.message);
      }
    } catch (error) {
      setLoader(false);
      error?.data?.data && alert(error?.data?.data || error.data?.message);
    }
  };
  const getGroupLists = async (programsId) => {
    try {
      const response = await getGroupListForProgram({
        programIds: [programsId],
      });
      setLoader(false);
      if (response.status === 200) {
        setProgramGroups(
          response?.data?.data.map((dt) => {
            return dt._id;
          })
        );
      } else {
        alert(response?.data || response.message);
      }
    } catch (error) {
      setLoader(false);
      error?.data?.data && alert(error?.data?.data || error.data?.message);
    }
  };
  // To get All default program list
  const getDefaultProgramList = async () => {
    setLoader(true);
    setFilterData([]);
    try {
      const response = await getDefaultProgram();

      if (response.status === 200) {
        const result = response?.data?.data.filter((value) => {
          if (!value.isArchive && value.default) {
            return value;
          }
        });
        setFilterData(sortArrLatest(result));
        setProgramList(result);
      }
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };
  const changeStatus = async (programId) => {
    try {
      const response = await activateProgram(programId);
      if (response.status === 200) {
        document.getElementById("checkbox").checked = true;
        showToastSuccess(`Active program is updated`);
        // renderListRow();
      } else {
        showToastError(
          response?.data || response?.message || "Some error occurred"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  const deletePrograms = async (programId) => {
    try {
      const response = await deleteProgram(programId);
      if (response.status === 200) {
        showToastSuccess(`Program deleted successfully`);
        listTabs.active && getProgramList();
        listTabs.default && getDefaultProgramList();
        listTabs.assigned && getAssignedText();
        listTabs.archived && getArchivedText();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleRemoveAssignProgram = async (programId) => {
    let params = {
      programId: programId,
    };
    try {
      if (params.programId !== "") {
        const response = await removeAssignedProgramFromProvider(params);
        if (response.status === 200) {
          showToastSuccess(`Program Removed successfully`);
          listTabs.active && getProgramList();
          listTabs.default && getDefaultProgramList();
          listTabs.assigned && getAssignedText();
          listTabs.archived && getArchivedText();
        } else {
          showToastError(
            response?.data || response.message || "Some error occurred"
          );
        }
      } else {
        showToastError("ProgramId not Found");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const makeDefault = async (programId) => {
    try {
      const response = await setDefaultProgram(programId);
      if (response.status === 200) {
        // document.getElementById("checkbox").checked = true;
        showToastSuccess(`Action completed successfully`);
        listTabs.active && getProgramList();
        listTabs.default && getDefaultProgramList();
        listTabs.assigned && getAssignedText();
        listTabs.archived && getArchivedText();
      } else {
        showToastError(
          response?.data || response.message || "Some error occurred"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };
  const renderLoader = () => {
    return (
      <Loader
        visible={isLoading}
        emptyTextKey={"noAnyActiveProgram"}
        style={{ top: 0, position: "relative" }}
      />
    );
  };

  const renderList = () => {
    return (
      <tbody>
        {filterdata?.map((item) => {
          let updated =
            item.updatedBy &&
            (item.updatedBy !== item.createdBy
              ? item?.updatedBy
              : item?.createdBy);
          return (
            <>
              <tr
                key={item._id}
                className="pointer"
                onClick={(e) => {
                  if (listTabs.assigned) {
                    navigate("/activeprograminfo", {
                      state: {
                        program: item,
                        isFromCreate: false,
                        isFromAssigned: true,
                      },
                    });
                  } else {
                    navigate("/activeprograminfo", {
                      state: { program: item, isFromCreate: false },
                    });
                  }
                  e.stopPropagation();
                }}
              >
                <td className="text-muted col-1">
                  {/* <img
                  src={ApiConfig.ImageUrl + 'programs/' + item.createdBy + '/' + item.programImage}
                  onError={(e) => {
                    e.target.src = "images/dummy_image.jpg" //replacement image imported above
                  }}
                  alt=""
                /> */}
                  <img
                    src={
                      ApiConfig.ImageUrl +
                      "programs/" +
                      updated +
                      "/" +
                      item.programImage
                    }
                    alt="program"
                    onError={(e) => {
                      return (e.target.src =
                        ApiConfig.ImageUrl +
                        "programs/" +
                        item.createdBy +
                        "/" +
                        item.programImage);
                    }}
                    
                    className="member_listimage active-program-list-thumbnail"
                  />
                  {/* <SquareAvatar
                    src={
                      ApiConfig.ImageUrl +
                      "programs/" +
                      updated +
                      "/" +
                      item.programImage
                    }
                    className="member_listimage squre_image2"
                  /> */}
                </td>
                <td className="text-muted col-2">{`${item.programName}`}</td>
                {/* <td className="text-muted">
                  <label className="switch ms-0">
                    <input
                      type="checkbox"
                      id="checkbox"
                      onClick={(e) => {
                        if (item.status === false) {
                          // console.log(item._id)
                          e.stopPropagation();
                          changeStatus(item._id);
                        }
                      }}
                      checked={item.status}
                    />
                    <span className="slider round"></span>
                  </label>
                </td> */}
                {/* <td className="text-muted col-2">{`${item.description}`}</td> */}
                <td className="text-muted col-1">
                  {formatNewDateString(item.startDate)}
                </td>
                <td className="text-muted col-1">
                  {formatNewDateString(item.endDate)}
                </td>
                <td className="text-muted col-1">
                  { item?.programMembers?.length + item?.careTeamMembers?.length}
                </td>
                <td
                  className="text-muted fw-bold text-left overflow-visible col-lg-2"
                  style={{ cursor: "pointer" }}
                >
                  {/* <DeleteModal
                          title={'Delete'}
                          content1={'Are you sure you want to delete?'}
                          
                          modalId={'deletePrograms'}
                          button2={'No'}
                          button1={'Yes'}
                          onDelete={() =>
                            deletePrograms(programId)
                          }
                  onDelete={() => deletePrograms(item._id)}
                  onClick={() => { deletePrograms(item._id) }}
                        /> */}
                  {/* <span className="mb-0" data-bs-toggle="tooltip" data-bs-placement="top" title="View" onClick={() => navigate("/activeprograminfo", { state: { program: item } })}><MdPreview size="1.5em" /> </span> */}
                  {/* <span className="mb-0" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit" onClick={() => navigate("/activeprogram", { state: { program: item, isFromCreate: false } })}><FiMoreHorizontal size="1.5em" /></span> */}
                  <div className="d-flex gap-1">
                    <button
                      onClick={(e) => {
                        navigate("/activeprograminfo", {
                          state: { program: item },
                        });
                        e.stopPropagation();
                      }}
                      className="btn btn-light"
                    >
                      <AiFillEye className="mb-1" />
                    </button>
                    {!item.isArchive && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          if (listTabs.assigned) {
                            navigate("/activeprogram", {
                              state: {
                                program: item,
                                isFromCreate: false,
                                isFromAssigned: true,
                              },
                            });
                          } else if (listTabs.default) {
                            navigate("/activeprogram", {
                              state: {
                                program: item,
                                isFromCreate: false,
                                isFromDefault: true,
                              },
                            });
                          } else {
                            navigate("/activeprogram", {
                              state: { program: item, isFromCreate: false },
                            });
                          }
                          e.stopPropagation();
                        }}
                        className="btn btn-light"
                      >
                        <FiEdit className="mb-1" />
                      </button>
                    )}
                    {listTabs.archived && (
                      <button
                        data-bs-toggle={item.isArchive ? "modal" : ""}
                        data-bs-target={
                          item.isArchive ? "#program" + item._id : ""
                        }
                        className="btn btn-light"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <FiTrash className="mb-1" />
                      </button>
                    )}
                    {listTabs.active &&
                      !item?.careTeam.includes(
                        localStorage?.getItem("user_id")
                      ) && (
                        <button
                          className="btn btn-light"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (item.default && !item.isArchive) {
                              return addArchive(item._id);
                            }
                            if (!item.isArchive) {
                              return addArchive(item._id);
                            }
                          }}
                        >
                          <FiTrash className="mb-1" />
                        </button>
                      )}
                    {listTabs.default && (
                      <button
                        className="btn btn-light"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (item.default && !item.isArchive) {
                            return addArchive(item._id);
                          }
                        }}
                      >
                        <FiTrash className="mb-1" />
                      </button>
                    )}
                    {listTabs.assigned && (
                      <button
                        className="btn btn-light"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!item.isArchive) {
                            return addArchive(item._id);
                          }
                        }}
                      >
                        <FiTrash className="mb-1" />
                      </button>
                    )}

                    <Dropdown
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <Dropdown.Toggle
                        variant="light"
                        className="custom"
                        id="dropdown-basic"
                      >
                        <BsThreeDots className="icon" />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {/* <Dropdown.Item onClick={() => navigate("/activeprograminfo", { state: { program: item } })}>View</Dropdown.Item> */}

                        <Dropdown.Item
                          data-bs-toggle="modal"
                          data-bs-target="#assigngroupmodal1"
                          onClick={() => {
                            setSelectedProgram(item);
                            getGroupLists(item._id);
                          }}
                        >
                          Add to Groups
                        </Dropdown.Item>
                        {listTabs.assigned ? (
                          <Dropdown.Item
                            href="#/action-2"
                            data-bs-toggle="modal"
                            data-bs-target="#assignmembermodal1"
                            onClick={() => {
                              setSelectedProgram(item);
                              setProgramMembers(item.programMembers);
                              setOpen(true);
                              setAssignedModal(true);
                            }}
                          >
                            Add Members
                          </Dropdown.Item>
                        ) : (
                          <Dropdown.Item
                            href="#/action-2"
                            data-bs-toggle="modal"
                            data-bs-target="#assignmembermodal1"
                            onClick={() => {
                              setSelectedProgram(item);
                              setProgramMembers(item.programMembers);
                              setOpen(true);
                            }}
                          >
                             Add Members
                          </Dropdown.Item>
                        )}
                        {isAdmin ? (
                          <Dropdown.Item
                            href="#/action-1"
                            data-bs-toggle={
                              !(item?.careTeam?.length > 0) ? "modal" : ""
                            }
                            data-bs-target={
                              !(item?.careTeam?.length > 0)
                                ? "#assigngroupproviders"
                                : ""
                            }
                            onClick={() => {
                              if (item?.careTeam?.length > 0) {
                                showToastError(
                                  "Program Already Assigned to another Provider"
                                );
                              } else {
                                setSelectedProgram(item);
                                setProgramProviders(item.careTeam);
                              }
                            }}
                          >
                            Add Care Team
                          </Dropdown.Item>
                        ) : null}
                        <Dropdown.Item
                          href="#/action-4"
                          data-bs-toggle="modal"
                          data-bs-target="#shareModal"
                          onClick={() => getShareLink(item._id)}
                        >
                          Share Link
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() =>
                            navigate("/activeprogramtemplate", {
                              state: { program: item, isFromCreate: false },
                            })
                          }
                        >
                          Save as template
                        </Dropdown.Item>

                        {/* <Dropdown.Item onClick={() => navigate("/activeprogram", { state: { program: item, isFromCreate: false } })}>Edit</Dropdown.Item> */}
                        {isAdmin ? (
                          <Dropdown.Item
                            href="#/action-3"
                            onClick={() => {
                              makeDefault(item._id);
                            }}
                          >
                            {item.default === true
                              ? "Remove as Default"
                              : "Make Default"}
                          </Dropdown.Item>
                        ) : null}
                        {/* {item.isArchive === true ? (
                          <Dropdown.Item
                            href="#/action-5"
                            data-bs-toggle={item.isArchive ? "modal" : ""}
                            data-bs-target={
                              item.isArchive ? "#program" + item._id : ""
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        ) : null} */}
                        {item.isArchive === true ? (
                          <Dropdown.Item
                            href="#/action-6"
                            onClick={() => {
                              return addArchive(item._id);
                            }}
                          >
                            Unarchive
                          </Dropdown.Item>
                        ) : null}
                        {/* <span
                                onClick={() => setPostId(curElem._id)}
                              > <FaTrash data-bs-toggle="modal"
                                data-bs-target="#deletePosts" style={{ fontSize: "25px", padding: "5px" }} className="like_group me-0" /></span> */}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  {
                    <DeleteModal
                      button1={renderModal(item, "Remove", "Delete")}
                      content1={"Are you sure?"}
                      content2={renderModal(
                        item,
                        "You want to remove this Assigned Program",
                        "You want to delete this Program"
                      )}
                      modalId={`program${item._id}`}
                      keyId={item._id}
                      onDelete={(e) => {
                        e.stopPropagation();
                        if (
                          !isAdmin &&
                          assignedData?.length > 0 &&
                          item?.careTeam?.length > 0
                        ) {
                          handleRemoveAssignProgram(item._id);
                          getAssignedProgram();
                        } else {
                          deletePrograms(item._id);
                        }
                      }}
                      onCancel={(e) => {
                        e.stopPropagation();
                      }}
                      title={renderModal(item, "Remove", "Delete")}
                      button2={"cancel"}
                    />
                  }
                </td>
              </tr>
            </>
          );
        })}
      </tbody>
    );
  };

  const renderSearchHeader = () => {
    const menuClass = `dropdown-menu${dropDownList ? " show" : ""}`;
    return (
      <div className="d-flex mb-3">
        <div className="w-50">
          <h4 className="chidHeadFont">Programs</h4>
          <p className="resFont">See how your programs are doing</p>
        </div>
        <div className="w-50 d-flex justify-content-end">
          {/* <div className="actsearch_simple me-2">
            <FiSearch className="boxicon" />
            <input
              placeholder="Search for programs..."
              className="ms-2"
              onChange={(e) => onChangeSearchText(e)}
            />
          </div> */}

          <div className="dropdown me-2">
            <button
              onBlur={() => { setDropDownList(false) }}
              onClick={() => { setDropDownList(!dropDownList); //setDropDown(false) 
                }}
              className="btn btn-primary btn-custom position-relative dropdown-toggle " 
              type="button"
            >
              Sort
              <ul className={menuClass + " top-0 start-0 w-100"} style={{marginTop: '3.5em'}}>
                <li><a className="dropdown-item pointer" onClick={() => { 
                  nameSort(filterdata)
                   }}>Alphabetical Order</a></li>
                <li><a className="dropdown-item pointer" onClick={() => { 
                  membershipCountSort(filterdata)
                 }
                }>Membership Count</a></li>
                <li><a className="dropdown-item pointer" onClick={() => { 
                  dateSort(filterdata)
                 }
                }>Date Order</a></li>
              </ul>
            </button>
          </div>
          {/* <button
              onBlur={() => { setDropDownList(false) }}
              onClick={() => navigate("/createactiveprogram")}
              className="btn btn-primary btn-custom position-relative " 
              type="button"
            >
              <AiOutlinePlus className="me-2" />  Add Program
              
            </button> */}
          {/* <Dropdown>
            <Dropdown.Toggle
              id="dropdown-basic"
              to="/createactiveprogram"
              title="Add Program"
              className="btn btn-primary btn-custom"
            >
              <AiOutlinePlus className="me-2" /> Add Program
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => navigate("/createactiveprogram")}
              >
                Create New
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
          <Link
            to="/createactiveprogram"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Add Program"
            className="btn btn-primary btn-custom">
            <AiOutlinePlus className="me-2" /> Add Program
          </Link>

          {/* <Dropdown>
            <Dropdown.Toggle
              id="dropdown-basic"
              to="/createactiveprogram"
              title="Add Program"
              className="btn btn-primary btn-custom"
            >
              <AiOutlinePlus className="me-2" /> Add Program
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => navigate("/createactiveprogram")}>
                Create New
              </Dropdown.Item>
              <Dropdown.Item onClick={() => navigate("/")}>
                Add from Templates
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown> */}
        </div>
      </div>
    );
  };
  return (
    <>
      <Navbar program={true} />
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-2">
            <Sidebar />
          </div>
          <div className="col-md-10 py-4 px-lg-5 px-md-3">
            {/* <div className="container"> */}
            <div className="d-flex justify-content-between align-items-center">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li
                    className="breadcrumb-item cursor-pointer"
                    onClick={() => navigate("/")}
                  >
                    Home
                  </li>
                  <li
                    className="breadcrumb-item active fw-bold"
                    aria-current="page"
                  >
                    All Programs
                  </li>
                </ol>
              </nav>
              {/* <Dropdown>
                <Dropdown.Toggle
                  id="dropdown-basic"
                  to="/createactiveprogram"
                  title="Add Program"
                  className="btn btn-primary btn-custom"
                >
                  <AiOutlinePlus className="me-2" /> Add Program
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={() => navigate("/createactiveprogram")}
                  >
                    Create New
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="mt-3 px-2">
                  {renderSearchHeader()}
                  <div className="mt-3">
                    <div className="border-bottom d-flex justify-content-between align-items-center">
                      <div className="custom-tabs">
                        <b
                          onClick={() => {
                            setListTabs({ ...defaultTabs, active: true });
                            getProgramList();
                          }}
                          className={`px-3 border-bottom tab mb-0  ${listTabs.active && "active"
                            }`}
                          style={{
                            padding: "19px 10px",
                          }}
                        >
                          My Programs
                        </b>
                        {isAdmin && (
                          <b
                            onClick={() => {
                              setListTabs({ ...defaultTabs, default: true });
                              getDefaultProgramList();
                            }}
                            className={`px-3 border-bottom tab mb-0  ${listTabs.default && "active"
                              }`}
                            style={{
                              padding: "19px 10px",
                            }}
                          >
                            Default
                          </b>
                        )}
                        {/* <p onClick={() => { setListTabs({ ...defaultTabs, default: true }); getDefaultProgramList(); }} className={`px-3 border-bottom py-2 tab mb-0  ${listTabs.default && 'active'}`}>Default</p> */}
                        {!isAdmin && assignedData?.length > 0 && (
                          <b
                            onClick={() => {
                              setListTabs({ ...defaultTabs, assigned: true });
                              getAssignedText();
                            }}
                            className={`px-3 border-bottom tab mb-0  ${listTabs.assigned && "active"
                              }`}
                            style={{
                              padding: "19px 10px",
                            }}
                          >
                            Assigned
                          </b>
                        )}
                        <b
                          onClick={() => {
                            setListTabs({ ...defaultTabs, archived: true });
                            getArchivedText();
                          }}
                          className={`px-3 border-bottom tab mb-0  ${listTabs.archived && "active"
                            }`}
                          style={{
                            padding: "19px 10px",
                          }}
                        >
                          Archived
                        </b>
                      </div>
                      <div className="actsearch_simple me-2 w-25 mb-2">
                        <FiSearch className="boxicon" />
                        <input
                          placeholder="Search for programs..."
                          className="ms-2"
                          onChange={(e) => onChangeSearchText(e)}
                        />
                      </div>
                    </div>

                    {/* Active Tab */}
                    {listTabs.active && (
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <td className="py-4 tab_title text-center">Thumbnail</td>
                            <td className="py-4 tab_title">Program Title</td>
                            {/* <td
                              className="py-4 tab_title"
                              scope="col text-secondary"
                            >
                              Publish
                            </td> */}
                            {/* <td className="py-4 tab_title">
                              Program Description
                            </td> */}
                            <td className="py-4 tab_title">Created At</td>
                            <td className="py-4 tab_title">Ended At</td>
                            <td className="py-4 tab_title">Membership</td>
                            <td className="py-4 tab_title">Action</td>
                          </tr>
                        </thead>
                        {renderList()}
                      </table>
                    )}
                    {/* default tabs */}
                    {listTabs.default && (
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <td className="py-4 tab_title">Thumbnail</td>
                            <td className="py-4 tab_title">Program Title</td>
                            {/* <td
                              className="py-4 tab_title"
                              scope="col text-secondary"
                            >
                              Publish
                            </td> */}
                            {/* <td className="py-4 tab_title">
                              Program Description
                            </td> */}
                            <td className="py-4 tab_title">Created At</td>
                            <td className="py-4 tab_title">Ended At</td>
                            <td className="py-4 tab_title">Membership</td>
                            <td className="py-4 tab_title">Action</td>
                          </tr>
                        </thead>
                        {renderList()}
                      </table>
                    )}
                    {/* Assigned tabs */}
                    {listTabs.assigned && (
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <td className="py-4 tab_title">Thumbnail</td>
                            <td className="py-4 tab_title">Program Title</td>
                            {/* <td
                              className="py-4 tab_title"
                              scope="col text-secondary"
                            >
                              Publish
                            </td> */}
                            {/* <td className="py-4 tab_title">
                              Program Description
                            </td> */}
                            <td className="py-4 tab_title">Start Date</td>
                            <td className="py-4 tab_title">End Date</td>
                            <td className="py-4 tab_title">Members</td>
                            <td className="py-4 tab_title">Action</td>
                          </tr>
                        </thead>
                        {renderList()}
                      </table>
                    )}
                    {/* Archived Tab */}
                    {listTabs.archived && (
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <td className="py-4 tab_title">Thumbnail</td>
                            <td className="py-4 tab_title">Program Title</td>
                            {/* <td
                              className="py-4 tab_title"
                              scope="col text-secondary"
                            >
                              Publish
                            </td> */}
                            {/* <td className="py-4 tab_title">
                              Program Description
                            </td> */}
                            <td className="py-4 tab_title">Start Date</td>
                            <td className="py-4 tab_title">End Date</td>
                            <td className="py-4 tab_title">Members</td>
                            <td className="py-4 tab_title">Action</td>
                          </tr>
                        </thead>
                        {renderList()}
                        {/* <tbody>
                          {list?.map((item) => renderListRow(item))}
                        </tbody> */}
                      </table>
                    )}

                    <ShareLinkModal link={linkInput} />

                    <AssignProvidersModal
                      addMember={updateProviders}
                      members={programProviders}
                      setMembers={setProgramProviders}
                    />
                    <AssignMemberModal
                      addMember={updateProgram}
                      members={programMembers}
                      setMembers={setProgramMembers}
                      open={open}
                      handleOpen={(res) => {
                        setOpen(res);
                        setAssignedModal(res);
                      }}
                    />
                    <AssignGroupModal
                      addMember={updateGroups}
                      members={programGroups}
                      setMembers={setProgramsGroups}
                    />

                    {isLoading ? renderLoader() : null}
                  </div>
                </div>
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
      </div>
    </>
  );
};
export default ActiveProgramList;
